import { TextLink, Toggle, Typography } from "@drone-js/core";
import { HStack, VStack } from "apps/commons/components/Stack";
import type { ComplianceDetails, ProfileData } from "libs/codegen/property-onboarding";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { ComplianceDetailsFields } from "./ComplianceDetailsFields";

export const GovernmentControlController = () => {
    const {
        cmsData: {
            profile: {
                governmentControl,
                governmentControlDescription,
                governmentAuthority,
                addMoreGovernmentAuthority,
                removeGovernmentAuthority,
                removeGovernmentAuthorityConfirmation,
            },
        },
    } = useStaticDataAtomValue();
    const { control, setValue } = useFormContext<ProfileData>();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "governmentControls",
    });

    const handleToggle = (checked: boolean) => {
        if (checked) append({} as ComplianceDetails);
        else setValue("governmentControls", []);
    };

    return (
        <VStack gap="24">
            <HStack justifyContent="space-between" alignItems="center">
                <VStack gap="8">
                    <Typography variant="heading-default">{governmentControl}</Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {governmentControlDescription}
                    </Typography>
                </VStack>
                <Toggle
                    id="toggle-2"
                    ariaLabel="Enable Goverment Control"
                    selection={fields.length > 0 ? "selected" : "unselected"}
                    onChange={handleToggle}
                    data-element-name="govt-control-toggle"
                />
            </HStack>
            {fields.map((field, index) => (
                <ComplianceDetailsFields
                    key={field.id}
                    fieldPrefix={`governmentControls.${index}`}
                    index={index}
                    multiplePrefix={governmentAuthority}
                    multiple={fields.length > 1}
                    onRemove={() => remove(index)}
                    disableStateCityFields
                    removeModalTitle={removeGovernmentAuthority}
                    removeModalDescription={removeGovernmentAuthorityConfirmation}
                    prefixDataElementName="govt"
                    secondPrefixDataElementName="govt-authority"
                />
            ))}
            {fields.length > 0 && (
                <TextLink
                    label={addMoreGovernmentAuthority}
                    onClick={() => append({} as ComplianceDetails)}
                    data-element-name="add-govt-authority"
                />
            )}
        </VStack>
    );
};
